const getFileExtension = (fileName) => {
  var _a;
  if (!fileName || !fileName.includes(".")) {
    return "";
  }
  return (_a = fileName.split(".").pop()) == null ? void 0 : _a.toLowerCase();
};
const formatBytes = (bytes, decimals = 2) => {
  if (!+bytes || bytes <= 0) {
    return "0 B";
  }
  const k = 1e3;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["B", "KB", "MB", "GB", "TB", "PB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};
export {
  formatBytes,
  getFileExtension
};
